import { SHIP_FROM_ADDRESSES_ACTIONS, initialShipFromAddressesState } from './shipFromAddresses.types'

/**
 * @param {import('./shipFromAddresses.types').ShipFromAddressesSlice} state
 * @param {Object} action
 */
export function shipFromAddressesReducer(state = initialShipFromAddressesState, { type, payload }) {
  switch (type) {
    case SHIP_FROM_ADDRESSES_ACTIONS.SET_SHIP_FROM_ADDRESSES:
      return { ...state, data: payload }

    case SHIP_FROM_ADDRESSES_ACTIONS.SET_SHIP_FROM_ADDRESS:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case SHIP_FROM_ADDRESSES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case SHIP_FROM_ADDRESSES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case SHIP_FROM_ADDRESSES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
